// 开发环境
export default {
  //cookie域名
  DOMAIN_NAME: '.jlwtest.com',

  //二版接口
  WS_BASE_URL: 'ws://118.25.139.57:5010',
  BASE_URL: 'http://118.25.139.57:5020/',

  //三版接口与文件上传
  BASE_URL_V3: 'https://api.jlwgroups.com/api/',
  UPLOAD_URL: 'https://api.jlwgroups.com/api/harbor/tencent/cloud/cos/',

  //前端项目地址
  LOGIN_URL: 'http://www.jlwtest.com',
  REDIRECT_URL: 'http://console.jlwtest.com',
  BACKSTAGE_URL: 'http://admin.jlwtest.com',

  //前台商城
  RECEPTION_URL: 'http://mall.jlwtest.com',

  //对象存储参数
  BUCKET: 'test-jlwgroups-1257889624',
  REGION: 'ap-shanghai',
  UPLOAD_DOMAIN: 'https://file-cos.jlwgroups.com/',
  ACCESSPATH: 'upload/',

  isDebug: true
}



// WEBPACK FOOTER //
// ./src/config/local.config.js